import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Dropdown from '../Dropdown';
import Checkbox from '../Checkbox';
import Grid from '../Grid';
import './styles.css';

export default class HubsSportsField extends React.Component {
  static propTypes = {
    nameField: PropTypes.object,
    mensAssocField: PropTypes.object,
    mensDivField: PropTypes.object,
    mensConfField: PropTypes.object,
    initialValue: PropTypes.object,
    name: PropTypes.string,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { mensAssocField, mensDivField, mensConfField } = this.props;
    this.state = {
      assocs: mensAssocField && mensAssocField.getAllowedValues(),
      divs: mensDivField && mensDivField.getAllowedValues(),
      confs: mensConfField && mensConfField.getAllowedValues(),
    };
  }

  getLabel = () => {
    const { name, nameField } = this.props;
    if (name) {
      return name;
    }
    const typeText = nameField ? nameField.getAllowedValues().filter((x) => x.id === nameField.getValue())[0] : {};
    return typeText.label;
  }

  transformOptions = (options) => (options ? [
    {
      key: 'none',
      value: '',
      text: 'none',
    },
    ...options.map((option) => ({
      key: option.id,
      value: option.id,
      text: option.label,
    })),
  ] : [{
    key: 'none',
    value: '',
    text: 'none',
  }]);

  render() {
    const {
      initialValue,
      onChange,
    } = this.props;
    const { assocs, divs, confs } = this.state;
    return (
      <React.Fragment>
        <div styleName="sport-name-label">
          {this.getLabel() && (
            <label styleName="sport-type">
              Mens {this.getLabel()}
            </label>
          )}
        </div>
        <span styleName="menu-field-label">Varsity (select Association, Division, and Conference):</span>
        <div styleName="field">
          <label styleName="menu-field-label" htmlFor={`field-men-${this.getLabel()}-assoc`}>Association</label>
          <Dropdown
            placeholder="Association"
            id={`field-men-${this.getLabel()}-assoc`}
            data-cy={`Premium-Hem-Athletics-${this.getLabel()}-assoc`}
            styleName="dropdown-select"
            value={get(initialValue, 'men.association', '')}
            fieldName="men.association"
            onChange={onChange}
            options={this.transformOptions(assocs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-men-${this.getLabel()}-div`}>Division</label>
          <Dropdown
            placeholder="Division"
            id={`field-men-${this.getLabel()}-div`}
            data-cy={`Premium-Hem-Athletics-${this.getLabel()}-div`}
            styleName="dropdown-select"
            value={get(initialValue, 'men.division', '')}
            fieldName="men.division"
            onChange={onChange}
            options={this.transformOptions(divs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-men-${this.getLabel()}-conf`}>Conference</label>
          <Dropdown
            placeholder="Conference"
            id={`field-men-${this.getLabel()}-conf`}
            data-cy={`Premium-Hem-Athletics-${this.getLabel()}-conf`}
            styleName="dropdown-select"
            value={get(initialValue, 'men.conference', '')}
            fieldName="men.conference"
            onChange={onChange}
            options={this.transformOptions(confs)}
            selection
          />
        </div>
        <div styleName="menu-field-label">Others:</div>
        <Grid columns={2}>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Club', htmlFor: `field-men-${this.getLabel()}-club` }}
              checked={get(initialValue, 'men.others.club', '0') === '1'}
              fieldName="men.others.club"
              onChange={(e) => onChange(e, { fieldName: 'men.others.club', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Intramural', htmlFor: `field-men-${this.getLabel()}-intramural` }}
              data-cy={`Premium-Hem-Athletics-${this.getLabel()}-intramural-Checkbox`}
              checked={get(initialValue, 'men.others.intramural', '0') === '1'}
              fieldName="men.others.intramural"
              onChange={(e) => onChange(e, { fieldName: 'men.others.intramural', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
        </Grid>
        <div styleName="sport-name-label">
          {this.getLabel() && (
            <label styleName="sport-type">
              Womens {this.getLabel()}
            </label>
          )}
        </div>
        <span styleName="menu-field-label">Varsity (select Association, Division, and Conference):</span>
        <div styleName="field">
          <label styleName="menu-field-label" htmlFor={`field-women-${this.getLabel()}-assoc`}>Association</label>
          <Dropdown
            placeholder="Association"
            id={`field-women-${this.getLabel()}-assoc`}
            styleName="dropdown-select"
            value={get(initialValue, 'women.association', '')}
            fieldName="women.association"
            onChange={onChange}
            options={this.transformOptions(assocs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-women-${this.getLabel()}-div`}>Division</label>
          <Dropdown
            placeholder="Division"
            id={`field-women-${this.getLabel()}-div`}
            styleName="dropdown-select"
            value={get(initialValue, 'women.division', '')}
            fieldName="women.division"
            onChange={onChange}
            options={this.transformOptions(divs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-women-${this.getLabel()}-conf`}>Conference</label>
          <Dropdown
            placeholder="Conference"
            id={`field-women-${this.getLabel()}-conf`}
            styleName="dropdown-select"
            value={get(initialValue, 'women.conference', '')}
            fieldName="women.conference"
            onChange={onChange}
            options={this.transformOptions(confs)}
            selection
          />
        </div>
        <div styleName="menu-field-label">Others:</div>
        <Grid columns={2}>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Club', htmlFor: `field-women-${this.getLabel()}-club` }}
              checked={get(initialValue, 'women.others.club', '0') === '1'}
              fieldName="women.others.club"
              onChange={(e) => onChange(e, { fieldName: 'women.others.club', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Intramural', htmlFor: `field-women-${this.getLabel()}-intramural` }}
              checked={get(initialValue, 'women.others.intramural', '0') === '1'}
              fieldName="women.others.intramural"
              onChange={(e) => onChange(e, { fieldName: 'women.others.intramural', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
        </Grid>
        <div styleName="sport-name-label">
          {this.getLabel() && (
            <label styleName="sport-type">
              Coed {this.getLabel()}
            </label>
          )}
        </div>
        <span styleName="menu-field-label">Varsity (select Association, Division, and Conference):</span>
        <div styleName="field">
          <label styleName="menu-field-label" htmlFor={`field-coed-${this.getLabel()}-assoc`}>Association</label>
          <Dropdown
            placeholder="Association"
            id={`field-coed-${this.getLabel()}-assoc`}
            styleName="dropdown-select"
            value={get(initialValue, 'coed.association', '')}
            fieldName="coed.association"
            onChange={onChange}
            options={this.transformOptions(assocs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-coed-${this.getLabel()}-div`}>Division</label>
          <Dropdown
            placeholder="Division"
            id={`field-coed-${this.getLabel()}-div`}
            styleName="dropdown-select"
            value={get(initialValue, 'coed.division', '')}
            fieldName="coed.division"
            onChange={onChange}
            options={this.transformOptions(divs)}
            selection
          />
          <label styleName="menu-field-label" htmlFor={`field-coed-${this.getLabel()}-conf`}>Conference</label>
          <Dropdown
            placeholder="Conference"
            id={`field-coed-${this.getLabel()}-conf`}
            styleName="dropdown-select"
            value={get(initialValue, 'coed.conference', '')}
            fieldName="coed.conference"
            onChange={onChange}
            options={this.transformOptions(confs)}
            selection
          />
        </div>
        <div styleName="menu-field-label">Others:</div>
        <Grid columns={2}>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Club', htmlFor: `field-coed-${this.getLabel()}-club` }}
              checked={get(initialValue, 'coed.others.club', '0') === '1'}
              fieldName="coed.others.club"
              onChange={(e) => onChange(e, { fieldName: 'coed.others.club', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
          <Grid.Column>
            <Checkbox
              label={{ children: 'Intramural', htmlFor: `field-coed-${this.getLabel()}-intramural` }}
              checked={get(initialValue, 'coed.others.intramural', '0') === '1'}
              fieldName="coed.others.intramural"
              onChange={(e) => onChange(e, { fieldName: 'coed.others.intramural', value: e.target.checked ? '1' : '0' })}
            />
          </Grid.Column>
        </Grid>
      </React.Fragment>
    );
  }
}
